import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { Loader } from "../_metronic/_partials/Loader";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import "../assets/css/BackendStyle.css";
import IdleTimerContainer from "./IdleTimerContainer";
import { ShortListPage } from "./pages/ShortListPage";

const SearchResultTheme1 = React.lazy(() =>
    import(`../_metronic/_partials/theme1`).then((module) => ({
        default: module.SearchResultTheme1,
    })),
);
const SearchDiamondTheme1 = React.lazy(() =>
    import(`../_metronic/_partials/theme1`).then((module) => ({
        default: module.SearchDiamondTheme1,
    })),
);
const GridCardTheme1 = React.lazy(() =>
    import(`../_metronic/_partials/theme1`).then((module) => ({
        default: module.GridCardTheme1,
    })),
);

const SearchDiamondTheme2 = React.lazy(() =>
    import(`../_metronic/_partials/theme2`).then((module) => ({
        default: module.SearchDiamondTheme2,
    })),
);

const SearchDiamondTheme3 = React.lazy(() =>
    import(`../_metronic/_partials/theme3`).then((module) => ({
        default: module.SearchDiamondTheme3,
    })),
);

const ProductDetailMain = React.lazy(() =>
    import(`../_metronic/_partials/commonComponents/ProductDetailMain`).then(
        (module) => ({
            default: module.ProductDetailMain,
        }),
    ),
);

export default function BasePage({
    theme,
    user,
    ruleData,
    naturalData,
    naturalFancyData,
    labData,
    labFancyData,
    language,
    themeData,
}) {
    return (
        <>
            <IdleTimerContainer themeData={themeData} />
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <Redirect exact from="/" to="/searchdiamond" />
                    {/* new */}
                    {theme === "theme1" ? (
                        <>
                            {/* theme1  */}
                            <ContentRoute
                                path="/search-result"
                                component={() => (
                                    <SearchResultTheme1 language={language} />
                                )}
                            />
                            <ContentRoute
                                path="/grid"
                                component={() => (
                                    <GridCardTheme1 language={language} />
                                )}
                            />
                            <ContentRoute
                                path="/details"
                                component={() => (
                                    <ProductDetailMain
                                        theme="theme1"
                                        language={language}
                                    />
                                )}
                            />
                            <ContentRoute
                                path="/shortlist"
                                component={() => (
                                    <ShortListPage
                                        language={language}
                                        themeData={themeData}
                                        user={user}
                                    />
                                )}
                            />
                            <ContentRoute
                                path="/searchdiamond"
                                component={() => (
                                    <SearchDiamondTheme1
                                        ruleData={ruleData}
                                        user={user}
                                        naturalData={naturalData}
                                        naturalFancyData={naturalFancyData}
                                        labData={labData}
                                        labFancyData={labFancyData}
                                        language={language}
                                    />
                                )}
                            />
                        </>
                    ) : theme === "theme2" ? (
                        <>
                            {/* theme2  */}
                            <ContentRoute
                                path="/search-result"
                                component={() => (
                                    <Redirect to="/searchdiamond" />
                                )}
                            />
                            <ContentRoute
                                path="/grid"
                                component={() => (
                                    <Redirect to="/searchdiamond" />
                                )}
                            />
                            <ContentRoute
                                path="/details"
                                component={() => (
                                    <ProductDetailMain
                                        theme="theme2"
                                        language={language}
                                    />
                                )}
                            />
                            <ContentRoute
                                path="/shortlist"
                                component={() => (
                                    <ShortListPage
                                        language={language}
                                        themeData={themeData}
                                        user={user}
                                    />
                                )}
                            />
                            <ContentRoute
                                path="/searchdiamond"
                                component={() => (
                                    <SearchDiamondTheme2
                                        ruleData={ruleData}
                                        user={user}
                                        naturalData={naturalData}
                                        naturalFancyData={naturalFancyData}
                                        labData={labData}
                                        labFancyData={labFancyData}
                                        language={language}
                                    />
                                )}
                            />
                        </>
                    ) : theme === "theme3" ? (
                        <>
                            {/* theme3  */}
                            <ContentRoute
                                path="/search-result"
                                component={() => (
                                    <Redirect to="/searchdiamond" />
                                )}
                            />
                            <ContentRoute
                                path="/grid"
                                component={() => (
                                    <Redirect to="/searchdiamond" />
                                )}
                            />
                            <ContentRoute
                                path="/details"
                                component={() => (
                                    <ProductDetailMain
                                        theme="theme2"
                                        language={language}
                                    />
                                )}
                            />
                            <ContentRoute
                                path="/shortlist"
                                component={() => (
                                    <ShortListPage
                                        language={language}
                                        themeData={themeData}
                                        user={user}
                                    />
                                )}
                            />
                            <ContentRoute
                                path="/searchdiamond"
                                component={() => (
                                    <SearchDiamondTheme3
                                        ruleData={ruleData}
                                        user={user}
                                        naturalData={naturalData}
                                        naturalFancyData={naturalFancyData}
                                        labData={labData}
                                        labFancyData={labFancyData}
                                        language={language}
                                    />
                                )}
                            />
                        </>
                    ) : (
                        <>
                            <ContentRoute
                                path="/searchdiamond"
                                component={Loader}
                            />
                        </>
                    )}
                    <Redirect to="error/error-v1" />
                </Switch>
            </Suspense>
        </>
    );
}
